import React from "react";
import PropTypes from "prop-types";
import { WalletBtns, WalletContainer, WalletHeader, WalletInputField } from "../auth/wallet/walletStyles";
import { useDispatch } from "react-redux";
import { toggleActivateWalletModal } from "../redux/WalletSlice";
import { Box } from "@mui/material";

const AddBvn = ({ handleChange, handleChangeTwo, bvn, homeAddress, onGreenBtnClick, isLoading }) => {
	const dispatch = useDispatch();

	const onCloseModal = () => {
		dispatch(toggleActivateWalletModal(false));
	};

	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText='Add BVN'
					onCloseModal={onCloseModal}
					context='Provide you details in the fields below'
				/>
				<Box sx={{ marginTop: 2, display: "flex", flexDirection: "column", gap: "14px" }}>
					<Box display='flex' flexDirection='column' gap={1}>
						<label htmlFor='bvn'>BVN</label>
						<WalletInputField
							name='bvn'
							value={bvn}
							onChange={handleChange}
							placeholder='Enter BVN (11 digits)'
							maxLength={11}
							style={{ width: "100%" }}
						/>
					</Box>
					<Box display='flex' flexDirection='column' gap={1}>
						<label htmlFor='homeAddress'>Home Address</label>
						<WalletInputField
							name='homeAddress'
							value={homeAddress}
							onChange={handleChangeTwo}
							placeholder='Enter Address'
							style={{ width: "100%" }}
						/>
					</Box>
				</Box>
				<WalletBtns
					hideWhiteBtn
					greenBtnClick={onGreenBtnClick}
					whiteBtnClick={onCloseModal}
					btnText='verify'
					isGreenBtnDisabled={bvn.length !== 11}
					isLoading={isLoading}
				/>
			</>
		</WalletContainer>
	);
};

export default AddBvn;

AddBvn.propTypes = {
	onGreenBtnClick: PropTypes.func,
	handleChange: PropTypes.func,
	handleChangeTwo: PropTypes.func,
	bvn: PropTypes.string,
	homeAddress: PropTypes.string,
	isLoading: PropTypes.bool,
};
